import { Skeleton } from "../ui/skeleton";

const LazyFallback = () => (
  <div className="space-y-2 p-4">
    <Skeleton className="h-8 w-1/2" />
    <Skeleton className="h-32 w-full" />
    <Skeleton className="h-8 w-full" />
    <Skeleton className="h-8 w-3/4" />
    <Skeleton className="h-8 w-5/6" />
  </div>
);

export default LazyFallback;
